import { Component, OnInit, Input } from "@angular/core";
import { LessonCard } from "src/app/Models/lessons.interface";
import { LessonManagerService } from "src/app/Services/LessonManager/lesson-manager.service";
import {
  transition,
  state,
  style,
  animate,
  trigger,
} from "@angular/animations";

@Component({
  selector: "app-lesson-card",
  templateUrl: "./lesson-card.component.html",
  styleUrls: ["./lesson-card.component.css"],
})
export class LessonCardComponent implements OnInit {
  @Input() id: number;
  lesson: LessonCard;
  constructor(private ls: LessonManagerService) {}

  ngOnInit(): void {
    this.lesson = this.ls.getCard(this.id);
    console.log(this.lesson);
  }
}
